import { useState, useEffect } from "react";
import { useLocalStorage } from "./useLocalStorage";


export const useUser = () => {

	const [user, setUser] = useState(null);
	//console.log("user", user)
	const [token, setToken] = useState(null);
	//console.log("TOKEN", token)
	const [role, setRole] = useState(null);
	const [userId, setUserId] = useState(null);
	const [mustChangePassword, setMustChangePassword] = useState(false);
	const [isEspecial, setIsEspecial] = useState(false);
	const [userMunicipio, setUserMunicipio] = useState(null);
	const [entidadId, setEntidadId] = useState(null);
	//console.log("ROLE", role)

	//const prueba = "pruebaA" //#comentar 18ENE25
	const { setItem, removeItem, getItem } = useLocalStorage();

	// Efecto para cargar role desde localStorage al inicializar
	useEffect(() => {
		const storedRole = getItem("role");
		if (storedRole) {
			try {
				const parsed = JSON.parse(storedRole);
				setRole(parsed);
			} catch (e) {
				console.error("Error parsing role from localStorage:", e);
			}
		}
	}, []);

	// Efecto para cargar userMunicipio desde localStorage al inicializar
	useEffect(() => {
		const storedUserMunicipio = getItem("userMunicipio");
		if (storedUserMunicipio) {
			try {
				const parsed = JSON.parse(storedUserMunicipio);
				setUserMunicipio(parsed);
			} catch (e) {
				console.error("Error parsing userMunicipio from localStorage:", e);
			}
		}
	}, []);

	// Efecto para cargar entidadId desde localStorage al inicializar
	useEffect(() => {
		const storedEntidadId = getItem("entidadId");
		if (storedEntidadId) {
			try {
				const parsed = JSON.parse(storedEntidadId);
				setEntidadId(parsed);
			} catch (e) {
				console.error("Error parsing entidadId from localStorage:", e);
			}
		}
	}, []);

	//const addUser = (user, token, role = 'user') => {
	const addUser = (user, token, role, userId, mustChangePass = false, isEspecialFlag = false, userMunicipioVal = null, entidadIdVal = null) => {
		//const userData = typeof user === 'string' ? { name: user, role } : { ...user, role };
		//setUser(userData);
		
		console.log('👤 useUser.addUser - userMunicipioVal:', userMunicipioVal, 'entidadIdVal:', entidadIdVal, 'tipo:', typeof entidadIdVal);
		setUser(user);
		setToken(token);
		setRole(role);
		setUserId(userId);
		setMustChangePassword(mustChangePass);
		setIsEspecial(isEspecialFlag);
		setUserMunicipio(userMunicipioVal);
		setEntidadId(entidadIdVal);

		try {
			setItem("user", JSON.stringify(user));
			setItem("token", JSON.stringify(token));
			setItem("role", JSON.stringify(role));
			setItem("userId", JSON.stringify(userId));
			setItem("mustChangePassword", JSON.stringify(mustChangePass));
			setItem("isEspecial", JSON.stringify(isEspecialFlag));
			const userMunJSON = JSON.stringify(userMunicipioVal);
			console.log('💾 Guardando userMunicipio en localStorage:', userMunJSON);
			setItem("userMunicipio", userMunJSON);
			console.log('✅ localStorage.userMunicipio guardado:', localStorage.getItem('userMunicipio'));
			const entidadIdJSON = JSON.stringify(entidadIdVal);
			console.log('💾 Guardando entidadId en localStorage:', entidadIdJSON);
			setItem("entidadId", entidadIdJSON);
			console.log('✅ localStorage.entidadId guardado:', localStorage.getItem('entidadId'));
		} catch (e) {
			console.error('❌ Error guardando en localStorage:', e);
		}
	};

	const removeUser = () => {
		setUser(null);
		setToken(null);
		setRole(null);
		setUserId(null);
		setMustChangePassword(false);
		setIsEspecial(false);
		setUserMunicipio(null);
		setEntidadId(null);
		removeItem("user");
		removeItem("token");
		removeItem("role");
		removeItem("userId");
		removeItem("mustChangePassword");
		removeItem("isEspecial");
		removeItem("userMunicipio");
		removeItem("entidadId");
	};

	const updateMustChangePassword = (value) => {
		setMustChangePassword(value);
		setItem("mustChangePassword", JSON.stringify(value));
	};

	return { user, addUser, removeUser, token, role, userId, mustChangePassword, updateMustChangePassword, isEspecial, userMunicipio, entidadId }; 
};